import { Link } from '@delmonicos/shared-design-system-react/src/components/link/link';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { GatewayRoleModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/roles/models/output/gateway-role.model';
import { CellContext } from '@tanstack/react-table';
import { generatePath, useNavigate } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';

export interface RoleListIdCellProps
  extends CellContext<GatewayRoleModel, GatewayRoleModel['id']> {}

export const RoleListIdCell = (
  props: RoleListIdCellProps,
): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { row, getValue } = props;
  const navigate = useNavigate();

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Link
      onClick={() =>
        navigate(generatePath(APP_PATH.ROLE.DETAILS, { id: row.original.id }))
      }>
      <Text truncate>{getValue()?.split('-')[0]}</Text>
    </Link>
  );
};
